// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import { getCurrentUser } from "./actions/currentUserProfileActions";
import { getCurrentUserRoles } from "./actions/currentUserRolesActions";
import RoofSnapAppBar from './containers/RoofSnapAppBar';
import SketchComponentHost from './containers/SketchComponentHost';
import Content from './Content';

type Props = {
    dispatch: Function,
    isAuthenticated: boolean,
};

export class App extends Component<Props> {
    async componentDidMount() {
        if (this.props.isAuthenticated) {
            await Promise.all([
                this.props.dispatch(getCurrentUser()),
                this.props.dispatch(getCurrentUserRoles())
            ]);
        }
        this.handleFoldspaceVisibility();
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.isAuthenticated !== this.props.isAuthenticated) {
            this.handleFoldspaceVisibility();
        }
    }

    handleFoldspaceVisibility = () => {
        if (typeof window !== 'undefined' && window.foldspace) {
            const isLoginPage = window.location.pathname === '/login';

            if (this.props.isAuthenticated && !isLoginPage) {
                window.foldspace('when', 'ready', function() {
                    window.foldspace.agent('roofsnap-agent').show();
                });
            } else {
                window.foldspace('when', 'ready', function() {
                    window.foldspace.agent('roofsnap-agent').hide();
                });
            }
        }
    }

    render() {
        return (
            <BrowserRouter>
                <div>
                    <RoofSnapAppBar />
                    {/* Needs to be outside of the main content of the app */}
                    <Route component={SketchComponentHost} />
                    <Content />
                </div>
            </BrowserRouter>
        );
    }
}

const mapStateToProps = (state) => {
    const { auth } = state;
    const { isAuthenticated } = auth;
    return {
        isAuthenticated
    };
};

export default connect(mapStateToProps)(App);
